import React, { memo } from 'react'
import classNames from 'classnames'
import { Checkbox } from '../Checkbox'
import { selecOptionStyles } from './SelectOptionStyles'

export interface ISelectOption<T = any> {
  label: string
  value: T
  className?: string
  description?: string
  /**
   * When an icon is not defined, nothing is displayed in the DOM.
   * This is an example icon that can be passed:
   * <AddIcon size='medium' />
   */
  icon?: JSX.Element
  isLink?: boolean
}

interface ISelectOptionProps extends ISelectOption {
  id?: string
  selected: boolean
  onSelect: (option: ISelectOption) => void
  dataTest: string
  checkbox?: boolean
  tooltip?: JSX.Element
  isEmptyState?: boolean
}

export const SelectOption = memo<ISelectOptionProps>(
  ({
    checkbox,
    className: classNameProp,
    dataTest,
    icon,
    id,
    isEmptyState = false,
    isLink,
    label,
    onSelect,
    selected,
    tooltip,
    value,
  }) => {
    const clickHandler = () => {
      if (!checkbox) {
        onSelect({ value, label })
      }
    }
    const checkboxHandler = () => {
      onSelect({ value, label })
    }

    const className = classNames('ellipsis', `${checkbox}`, { selected }, `${classNameProp}`, {
      'empty-state': isEmptyState,
    })

    const classes = selecOptionStyles()

    const linkClass = isLink ? classes.link : ''

    return (
      <button
        type='button'
        data-test={dataTest}
        onClick={clickHandler}
        role='option'
        aria-selected={selected}
        className={className}
        value={value}>
        <div className={`${linkClass} flex flex-row items-center`}>
          {!!icon && !checkbox && <>{icon}</>}
          {checkbox && (
            <Checkbox
              label={label}
              checked={selected}
              id={`${label}-${id}`}
              dataTest={`${label}-data-test`}
              tooltip={tooltip}
              onChange={checkboxHandler}
            />
          )}
          <div className='ml2 ellipsis'>{!checkbox && label}</div>
        </div>
      </button>
    )
  }
)
